import React from 'react'

import { NavLink } from 'react-router-dom'

import { List, ListItem, ListItemText, useTheme } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import { facilityOffersBarPark } from '../../utils/barPark'

/**
 * Training hidden from the nav (2026-08-27): no facility runs it. Routes/pages/API stay intact
 * and URL-reachable — flip to true to restore. FacilitySetupNavItems has its own copy.
 */
const SHOW_TRAINING = false

const useStyles = makeStyles((theme) => ({
	listItem: {
		fontFamily: 'Nunito',
		fontSize: 16,
		color: '#3B0275',
		opacity: 0.6,
		fontWeight: 'bold !important'
	}
}))

const NavItems = (props) => {
	const { selectedFacility, roles } = props

	const isGroomer = roles.length === 1 && roles.includes('Groomer')

	const classes = useStyles()
	return (
		<List className={classes.defaultNav}>
			{!isGroomer ? (
				<ListItem
					component={NavLink}
					exact
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/schedule`}>
					<ListItemText primary="Pet Care Schedule" />
				</ListItem>
			) : null}
			<ListItem
				component={NavLink}
				exact
				className={classes.listItem}
				to={`/facilities/${selectedFacility ? selectedFacility._id : null}/groomingHome`}>
				<ListItemText primary="Grooming" />
			</ListItem>
			{
				isGroomer || !SHOW_TRAINING ? null : (
					<ListItem
						component={NavLink}
						exact
						className={classes.listItem}
						to={`/facilities/${selectedFacility ? selectedFacility._id : null}/training/schedule`}>
						<ListItemText primary="Training" />
					</ListItem>
				)
			}
			{!isGroomer ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/monitor/activities`}>
					<ListItemText primary="Monitor" />
				</ListItem>
			) : null}
			{facilityOffersBarPark(selectedFacility) && !isGroomer ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/bar&park`}>
					<ListItemText primary="Bar & Park" />
				</ListItem>
			) : null}
			<ListItem component={NavLink} className={classes.listItem} to={`/clients`}>
				<ListItemText primary="Clients" />
			</ListItem>
			{!isGroomer ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/team`}>
					<ListItemText primary="Team" />
				</ListItem>
			) : null}
			{!isGroomer ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/settings`}>
					<ListItemText primary="Settings" />
				</ListItem>
			) : null}
			{!isGroomer ? (
				<ListItem
					component={NavLink}
					className={classes.listItem}
					to={`/facilities/${selectedFacility ? selectedFacility._id : null}/facilitySetup/basicInfo`}>
					<ListItemText primary="Facility Setup" />
				</ListItem>
			) : null}
		</List>
	)
}

export default NavItems
